/* global require */
'use strict';
require('./auth.html');
require('./bootstrap/deps');
require('./bootstrap/favicon-loader');
var mocksRegex = /[?&](debug[%5B\[]){0,1}mocks([%5D\]]){0,1}=1/;
var allowMocks = mocksRegex.test(location.search);
if (NODE_ENV === 'development' && allowMocks) {
    require('./bootstrap/auth-mocks');
}
require('./bootstrap/updated/auth-page').initAuth();
